import axios from "axios";
import { toast } from "sonner";
import { accessToken, refreshToken, updateAccess, clearSession, session, resumeSession } from "./session";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let companyId = null;
export const setCompanyContext = (id) => { companyId = id; };
export const getCompanyContext = () => companyId;

export const api = axios.create({ baseURL: API });
const SKIP = ["/auth", "/backoffice", "/admin", "/me/", "/ai/", "/meta", "/notifications", "/public"];

api.interceptors.request.use((cfg) => {
  const t = accessToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  if (companyId && !SKIP.some((s) => cfg.url.startsWith(s)) && !(cfg.params && cfg.params.company_id)) {
    cfg.params = { ...(cfg.params || {}), company_id: companyId };
  }
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const status = err.response?.status;
    if (status === 401 && !cfg._retry && !cfg.url?.startsWith("/auth/login") && (refreshToken() || session()?.remember)) {
      cfg._retry = true;
      try {
        refreshing = refreshing || (refreshToken()
          ? axios.post(`${API}/auth/refresh`, { refresh_token: refreshToken() }).then((r) => { updateAccess(r.data.access_token); return r.data.access_token; })
          : resumeSession([session().env]).then((t) => { if (!t) throw new Error("no session"); return t; }));
        await refreshing;
        return api(cfg);
      } catch {
        clearSession();
        window.location.href = "/login";
      } finally {
        refreshing = null;
      }
    }
    if (status === 409 && err.response?.data?.detail?.code === "competencia_fechada" && !cfg._pcAck) {
      if (window.confirm(err.response.data.detail.message)) {
        cfg._pcAck = true;
        cfg.headers = { ...(cfg.headers || {}), "X-Post-Closing-Ack": "1" };
        return api(cfg);
      }
      err.handled = true;
    }
    if (status === 423 && err.response?.data?.detail?.code === "financial_hold") {
      sessionStorage.setItem("dp_financial_hold", JSON.stringify(err.response.data.detail));
      clearSession();
      err.handled = true;
      if (window.location.pathname !== "/pendencia-financeira") window.location.href = "/pendencia-financeira";
      return Promise.reject(err);
    }
    if (status >= 500 && !cfg.silent) {
      toast.error("Não conseguimos concluir esta operação.", { description: "Seus dados foram preservados. Tente novamente ou entre em contato com nosso atendimento." });
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d && typeof d === "object" && !Array.isArray(d) && d.message) return e.handled ? "Alteração cancelada." : d.message;
  if (!d) return "Não conseguimos concluir esta operação. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function downloadFile(url, filename) {
  try {
    const res = await api.get(url, { responseType: "blob" });
    const href = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = href;
    a.download = filename || "arquivo";
    a.click();
    URL.revokeObjectURL(href);
    toast.success("Download iniciado", { description: filename });
  } catch (e) {
    let msg = "Não foi possível baixar o arquivo.";
    if (e?.response?.data instanceof Blob) {
      try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch { /* noop */ }
    }
    toast.error(msg);
  }
}


export async function viewFile(url) {
  const w = window.open("", "_blank");
  try {
    const res = await api.get(url, { responseType: "blob" });
    const href = URL.createObjectURL(res.data);
    if (w) w.location.href = href; else window.open(href, "_blank");
  } catch {
    w?.close();
    toast.error("Não foi possível abrir o arquivo.");
  }
}
